import { computed } from 'vue'

import type { InsuranceOffer } from '@backmarket/http-api/src/api-models/InsuranceOffer'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { VariantsEnum as TagVariants } from '@ds/components/Tag/Tag.constant'

import translations from './useInsuranceTagProps.translations'

export function useInsuranceTagProps(offers: InsuranceOffer[], index: number) {
  const i18n = useI18n()
  const experiments = useExperiments()

  const isAnnualRecurringIterationEnabled = computed(
    () =>
      experiments['experiment.annualRecurringIteration'] ===
      'withAnnualRecurringIteration',
  )

  const isMonthlyAndAnnuallyOffersGermany = computed(
    () =>
      experiments['experiment.monthlyAndAnnuallyOffersGermany'] ===
      'withMonthlyAndAnnually',
  )

  const isAnnuallyOfferAvailable = computed(() =>
    offers.some((offer) => offer.paymentFrequency === 'ANNUALLY'),
  )

  if (
    isAnnuallyOfferAvailable.value &&
    (isAnnualRecurringIterationEnabled.value ||
      isMonthlyAndAnnuallyOffersGermany.value)
  ) {
    return undefined
  }

  if (index === 0)
    return {
      label: i18n(translations.recommendedTag),
      variant: TagVariants.Primary,
    }

  return undefined
}
